export default function NavLabel({ primary, secondary, inline = false }) {
    if (primary && secondary) {
        if (inline) {
            return (
                <span>
                    <strong className="has-text-weight-bold">{primary}</strong>
                    <span className="has-text-weight-normal"> · {secondary}</span>
                </span>
            );
        }
        return (
            <>
                <strong>{primary}</strong>
                <span className="is-block has-text-weight-light">{secondary}</span>
            </>
        );
    }
    return <strong>{primary || secondary}</strong>;
}
